var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload system-upload-file" },
    [
      !_vm.uploading
        ? _c(
            "el-upload",
            {
              ref: "upload_" + _vm.type,
              attrs: {
                action: "#",
                "auto-upload": false,
                accept: _vm.acceptType,
                limit: _vm.limitNum,
                "on-change": _vm.handleFile.bind(this, _vm.type),
                "on-remove": _vm.handleRemove.bind(this, _vm.type),
                "on-exceed": _vm.handleFileExceed.bind(this, _vm.type),
                "file-list": _vm.fileList,
              },
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small", plain: "", type: "primary" } },
                [
                  _c("svg-icon", {
                    attrs: { "icon-class": "upload-mark-default" },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("tips.click_to_upload"))),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.uploading
        ? _c("div", { staticClass: "parse" }, [_vm._v(" Uploading ")])
        : _vm._e(),
      _c("Progress", { attrs: { progress: _vm.uploadingProgress } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }